import { create } from 'zustand';

interface UserState {
  user: {
    id: string;
    email: string;
    fullName: string;
    avatarUrl?: string;
    userType?: string;
  } | null;
  setUser: (user: UserState['user']) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null })
}));